import { render, staticRenderFns } from "./ModalGetMenuGoogleWarning.vue?vue&type=template&id=8ccc0854&scoped=true&lang=pug"
import script from "./ModalGetMenuGoogleWarning.vue?vue&type=script&lang=js"
export * from "./ModalGetMenuGoogleWarning.vue?vue&type=script&lang=js"
import style0 from "./ModalGetMenuGoogleWarning.vue?vue&type=style&index=0&id=8ccc0854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccc0854",
  null
  
)

export default component.exports